import styled from 'styled-components';
import { TransitionStatus } from 'react-transition-group/Transition';

export const FadeInTop = styled.div<{
  state: TransitionStatus;
}>`
  transition: 0.3s;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 999999;
  position: absolute;
  opacity: ${({ state }) => (state === 'entered' ? 1 : 0)};
  transform: translateY(${({ state }) => (state === 'entered' ? '0' : '16px')});
`;

export const FeedbackUploadBox = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  z-index: 99999999;
  top: 0;
  left: 0;
`;

export const FeedbackInner = styled.div<{
  type: 'error' | 'success';
}>`
  width: 90%;
  max-width: 400px;
  text-align: center;
  h4 {
    color: ${({ type, theme }) =>
      type === 'success' ? theme.colors.primary : theme.colors.red};
    font-weight: normal;
    font-size: 1.2rem;
  }

  p {
    color: ${({ theme }) => theme.colors.mediumGrey};
  }
`;
